import {Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {DetailConfigurationField} from "../../../models/detail-configuration-field";
import {HelperService} from "../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import * as CryptoJS from "crypto-js";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {DetailService} from "../../../services/details/detail.service";
import {DataTableDirective} from "angular-datatables";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'tig-tabs-object-array',
  templateUrl: './tabs-object-array.component.html',
  styleUrls: ['./tabs-object-array.component.scss']
})
export class TabsObjectArrayComponent implements OnInit {

  @Input()
  OBJ_field: DetailConfigurationField;
  @Input()
  BOO_allow_delete: boolean;
  @Input()
  OBJ_parent_form_group: FormGroup = null;
  @Input()
  STR_form_group_name: string;

  @ViewChild('OBJ_template_ref_modal_object', {static:false}) OBJ_template_ref_modal_object: TemplateRef<any>;
  @ViewChildren(DataTableDirective) OBJ_dt_elements: QueryList<DataTableDirective>;

  public MAP_bs_modal_ref: Map<string, BsModalRef> = new Map<string, BsModalRef>();
  public STR_object_name: string;
  public OBJ_dt_options;
  public BOO_new_object: boolean;

  private STR_id: string;
  private OBJ_group: FormGroup;


  constructor(
      private OBJ_helper_service: HelperService,
      private OBJ_translate_service: TranslateService,
      private OBJ_modal_service: BsModalService,
      private OBJ_detail_service: DetailService,
      private OBJ_form_builder: FormBuilder,
	  private OBJ_toastr_service: ToastrService,
  ) { }

  ngOnInit() {
    this.fillTableWithData();
    this.OBJ_group = this.OBJ_form_builder.group({});
    if(this.OBJ_parent_form_group)
    {
      this.OBJ_parent_form_group.addControl(this.STR_form_group_name, this.OBJ_group);
    } // end if
  }


  /**
   * Function > fillTableWithData
   */
  fillTableWithData()
  {

    if (this.OBJ_field !== undefined)
    {

      // get data
      let ARR_data = this.OBJ_field.value;
      // get config for listing
      let OBJ_config_listing = this.OBJ_field.listing;

      // add renderer to each column
      this.OBJ_helper_service.addRenderer(this.OBJ_field.listing.columns);

      /**
       * @see https://datatables.net/reference/option/dom
       *
       * frti Results in:
       * {filter}
       * {processing}
       * {table}
       * {information}
       *
       * Default: lfrtip
       */
      this.OBJ_dt_options = {
        data: ARR_data,
        columns: this.OBJ_field.listing.columns,
        searching: OBJ_config_listing.searchable ? OBJ_config_listing.searchable : false,
        lengthChange: false,
        ordering: true,
        order: OBJ_config_listing.order ? OBJ_config_listing.order : [],
        pageLength: 100,
        language: {
          url: "assets/i18n/datatables/" + this.OBJ_translate_service.currentLang + ".json"
        },
        responsive: true,
        dom: 'frti',
        // dom: 't',
        deferRender: false,
        rowCallback: (OBJ_row: Node, OBJ_data, INT_index: number) => {
          // wird auch bei Sortierung gerufen
        },
        createdRow: (OBJ_row: Node, OBJ_data, INT_index: number) => {
          $(OBJ_row).on('click', (OBJ_event) => {console.log('click');
            this.STR_id = CryptoJS.MD5(JSON.stringify(OBJ_data)).toString();
            this.OBJ_field.fields.forEach((OBJ_item) => {
              OBJ_item.value = OBJ_data[OBJ_item.name];
            });
            this.openModal(this.OBJ_template_ref_modal_object, this.OBJ_field.name);
          });
        }
      };

    } // end if

  } // end function fillTableWithData

  /**
   * Function > openModal
   * @param {TemplateRef<any>} OBJ_template_ref
   * @param {string} STR_name
   * @param {string} STR_object_name
   * @return {void}
   */
  openModal(OBJ_template_ref: TemplateRef<any>, STR_name, STR_object_name = null): void
  {

    this.STR_object_name = STR_object_name;
    this.MAP_bs_modal_ref.set(
        STR_name,
        this.OBJ_modal_service.show(OBJ_template_ref, {
          animated: true,
          keyboard: true,
          backdrop: true,
          ignoreBackdropClick: true,
          class: "tig-modal-dialog"
        })
    );


  } // end function openModal


  /**
   * Function > hideModal
   * @param {string} STR_type
   * @return {void}
   */
  hideModal(STR_type): void
  {
    this.MAP_bs_modal_ref.get(STR_type).hide();
  } // end function hideModal

  /**
   * Function > newObject
   */
  newObject()
  {

    this.BOO_new_object = true;
    if (this.OBJ_field !== undefined)
    {

      this.OBJ_field.fields.forEach((OBJ_item) => {
        OBJ_item.value = null;
      });
      this.openModal(this.OBJ_template_ref_modal_object, this.OBJ_field.name);

    } // end if

  } // end function newObject


  /**
   * Function > applyObject
   * @param OBJ_form_group
   */
  applyObject(OBJ_form_group)
  {



	  if (OBJ_form_group.invalid)
	  {
		  this.OBJ_toastr_service.error(this.OBJ_translate_service.instant('oError.sInvalidFields'));
	  }
	  else
	  {
		  if (this.BOO_new_object)
		  {

			  let OBJ_new_entry = $.extend(true, {}, this.OBJ_field.object_structure);
			  Object.keys(OBJ_form_group.controls).forEach((OBJ_item) => {

				  let MIX_value = OBJ_form_group.controls[OBJ_item].value;
				  if (MIX_value && MIX_value.toISOString)
				  {
					  MIX_value = MIX_value.toISOString();
				  } // end if
				  OBJ_new_entry[OBJ_item] = MIX_value;

			  });

			  this.OBJ_field.value.push(OBJ_new_entry);
			  this.BOO_new_object = false;

		  }
		  else
		  {

			  // get array with objects
			  let ARR_data = this.OBJ_detail_service.OBJ_detail_content.getValue(this.OBJ_field.name);

			  // find object with id
			  let OBJ_entry = ARR_data.find((OBJ_item) => {
				  return CryptoJS.MD5(JSON.stringify(OBJ_item)).toString() === this.STR_id;
			  });

			  // update object
			  Object.keys(OBJ_entry).forEach((STR_key) => {

				  if (typeof OBJ_form_group.controls[STR_key] !== 'undefined')
				  {

					  let MIX_value = OBJ_form_group.controls[STR_key].value;
					  if (MIX_value && MIX_value.toISOString)
					  {
						  MIX_value = MIX_value.toISOString();
					  } // end if
					  OBJ_entry[STR_key] = MIX_value;

				  } // end if

			  });

		  } // end if

		  // Mark as edited by user to prevent lossing unsaved data on navigation
		  this.OBJ_group.markAsDirty();
		  this.OBJ_group.markAsTouched();

		  // hide modal
		  this.MAP_bs_modal_ref.get(this.OBJ_field.name).hide();
		  this.MAP_bs_modal_ref.delete(this.OBJ_field.name);

		  // rerender datatable
		  this.rerenderDataTable();
	  } // end if

  } // end function applyObject

  /**
   * Function > remove
   * @desc {number} INT_id
   * @return {void}
   */
  remove(): void
  {

    // get array with objects
    let ARR_data: Array<any> = this.OBJ_detail_service.OBJ_detail_content.getValue(this.OBJ_field.name);

    // remove object
    ARR_data.splice(
        ARR_data.findIndex(
            OBJ_item => CryptoJS.MD5(JSON.stringify(OBJ_item)).toString() === this.STR_id
        ), 1
    );

    // hide modal
    this.MAP_bs_modal_ref.forEach((OBJ_bs_modal_ref: BsModalRef, STR_key: string) => {
      OBJ_bs_modal_ref.hide();
      this.MAP_bs_modal_ref.delete(STR_key);
    });
    this.OBJ_modal_service.hide(1);

	// Mark as edited by user to prevent lossing unsaved data on navigation
    this.OBJ_group.markAsDirty();
    this.OBJ_group.markAsTouched();

    // rerender datatable
    this.rerenderDataTable();

  } // end function remove

  /**
   * Function > rerenderDataTable
   */
  private rerenderDataTable(): void
  {

    this.OBJ_dt_elements.forEach((OBJ_dt_element: DataTableDirective) => {
      if ((OBJ_dt_element as any).el.nativeElement.id === 'tig-dt-element-objects') {
        OBJ_dt_element.dtInstance.then((OBJ_dt_instance: DataTables.Api) => {
          OBJ_dt_instance.clear().draw();
          let ARR_data = this.OBJ_field.value;
          OBJ_dt_instance.rows.add(ARR_data);
          OBJ_dt_instance.columns.adjust().draw();
        });
      } // end if
    });

  } // end function rerenderDataTable


}
